import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddBoardUserComponent } from './add-board-user/add-board-user.component';
import { ApplyDuplicateMarksheetComponent } from './apply-duplicate-marksheet/apply-duplicate-marksheet.component';
import { ApplyDuplicatePassingCertificateComponent } from './apply-duplicate-passing-certificate/apply-duplicate-passing-certificate.component';
import { ApplyNameChangeOnPassingcertificateComponent } from './apply-name-change-on-passingcertificate/apply-name-change-on-passingcertificate.component';
import { ApplyNameChangeComponent } from './apply-name-change/apply-name-change.component';
import { ApplyNewMigrationCertificateComponent } from './apply-new-migration-certificate/apply-new-migration-certificate.component';
import { BoardloginComponent } from './boardlogin/boardlogin.component';
//import { ApplyNewMigrationCertificateComponent } from './apply-new-migration-certificate.component.';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DuplicateMigrationCertificateComponent } from './duplicate-migration-certificate/duplicate-migration-certificate.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { GenerateMigrationCertificateComponent } from './generate-migration-certificate/generate-migration-certificate.component';
import { LoginComponent } from './login/login.component';
import { MyapplicationComponent } from './myapplication/myapplication.component';
import { MyprofileComponent } from './myprofile/myprofile.component';
import { PaymentResponceLandingComponent } from './payment-responce-landing/payment-responce-landing.component';
import { RegisterComponent } from './register/register.component';
import { UpdatefeesComponent } from './updatefees/updatefees.component';
import { UpdaterequeststatusComponent } from './updaterequeststatus/updaterequeststatus.component';
import { ViewAllOtherRequestsComponent } from './view-all-other-requests/view-all-other-requests.component';
import { ViewallrequestComponent } from './viewallrequest/viewallrequest.component';
import { ViewapplicationstatusComponent } from './viewapplicationstatus/viewapplicationstatus.component';
import { ViewpdfComponent } from './viewpdf/viewpdf.component';
const routes: Routes = [
// examiner- boardCoordinator
// data:{roles: [Role.Examiner]}
 {path:'',component:LoginComponent},
 {path:'Login', component:LoginComponent},
 {path:'dashboard',component:DashboardComponent},
 {path:'myapplication',component:MyapplicationComponent},
 {path:'myprofile',component:MyprofileComponent},
 //{path:'applynewmigrationcertificate',component:ApplyNewMigrationCertificateComponent},
 {path:'viewapplicationstatus', component:ViewapplicationstatusComponent},
 {path:'viewpdf', component:ViewpdfComponent},
 {path:'register',component:RegisterComponent},
 {path:'applynewmigration',component:ApplyNewMigrationCertificateComponent},
 {path:'applynamechange',component:ApplyNameChangeComponent},//name change on marksheet
 {path:'applynamechangeonpassingcertificate',component:ApplyNameChangeOnPassingcertificateComponent},
 {path:'applyduplicatemigration',component:DuplicateMigrationCertificateComponent},
 {path:'applyduplicatepassing',component:ApplyDuplicatePassingCertificateComponent},
 {path:'applyduplicatemarsksheet',component:ApplyDuplicateMarksheetComponent},
 {path:'viewallmigrationrequest',component:ViewallrequestComponent},
 {path:'viewrequest/:req',component:ViewAllOtherRequestsComponent},
 {path:'updaterequeststatus',component:UpdaterequeststatusComponent},
 {path:'updatefees',component:UpdatefeesComponent},
 {path:'boardadminlogin', component:BoardloginComponent},
 {path:'resetpassword/:user', component:ForgetpasswordComponent},
 {path:'payment-status/:code', component:PaymentResponceLandingComponent},
 {path:'generatemigrationcertificate', component:GenerateMigrationCertificateComponent},
 {path:'addboarduser', component:AddBoardUserComponent},
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule]
// })
@NgModule({
  imports: [RouterModule.forRoot(routes,{
         useHash: true
    
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
